<template>
  <div class="welink-code-con">
    <div class="welink-qrcode">
      <div id="qrcode" :style="styleObj"></div>
    </div>
  </div>
</template>
<script>
import { welinkToken, weLinkBind } from "@/api/courseApi";
import cookie from "@/utils/cookie.js";
import { UMOOC_COOKIE_DOMAIN } from "@/config";
export default {
  props: ["inside"],
  data() {
    return {
      styleObj: {},
      token: this.$route.query.token,
      isLogin: this.$route.query.isLogin,
    };
  },
  created() {
    // this.clear()
    var _this = this;
    this.loadScript(
      "https://login.welink.huaweicloud.com/sso-proxy-front/public/qrcode/0.0.1/wlQrcodeLogin.js",
      () => {
        var obj = wlQrcodeLogin({
          id: "qrcode", //这里需要你在自己的页面定义一个HTML标签并设置id，例如<div id="qrcode"></div>或<span id="qrcode"></span>
          client_id: "20221122141855572801658",
          response_type: "code",
          scope: "snsapi_login",
          state: "eiere84585",
          redirect_uri: `https://smartclassroom.tongshike.cn`, //请参考注释里的方式
          // redirect_uri: "http://localhost:8080", //请参考注释里的方式
          style: "border:none;background-color:#FFFFFF;",
          height: 260,
          self_redirect: true,
        });
        var handleMessage = function (event) {
          var origin = event.origin;
          if (origin == "https://login.welink.huaweicloud.com") {
            //判断是否来自WeLink wlLogin扫码事件。 测试环境先注释，上线后需放开
            var loginCode = event.data;
            //拿到loginCode后就可以在这里构造跳转链接进行跳转了
            if (loginCode) {
              _this.byCodeTo(loginCode);
            }
          }
        };
        if (typeof window.addEventListener != "undefined") {
          window.addEventListener("message", handleMessage, false);
        } else if (typeof window.attachEvent != "undefined") {
          window.attachEvent("onmessage", handleMessage);
        }
      }
    );
  },
  mounted() {
    const dom = document.querySelector(".welink-qrcode");
    const scale = 1;
    dom.style.height = `${260 * scale}px`;
    this.styleObj = {
      transform: `scale(${scale})`,
      "-webkit-transform": `scale(${scale})`,
      "-moz-transform": `scale(${scale})`,
    };
  },
  methods: {
    byCodeTo(code) {
      this.weLinkLogin(code);
    },
    loadScript(path, callBack) {
      const url = path;
      const script = document.createElement("script");
      script.src = url;
      script.onload = script.onreadystatechange = function () {
        if (
          !this.readyState ||
          this.readyState === "loaded" ||
          this.readyState === "complete"
        ) {
          callBack && callBack();
          this.onload = this.onreadystatechange = null;
        }
      };
      document.head.appendChild(script);
      return script;
    },
    weLinkLogin(code) {
      welinkToken({ code })
        .then((res) => {
          //0 code失效
          //1 已绑定
          //2 未绑定
          if (res.code == 1) {
            if (this.isLogin) {
              cookie.set("USER_INFO", JSON.stringify(res.result));
              cookie.set("AUTHORIZATION", res.result.authorization);
              cookie.set("token", res.result.authorization);
              // window.location.href = "http://192.168.100.192:8000/ulearning/index.html#/index/courseList";
              window.location.href = "https://courseweb" + UMOOC_COOKIE_DOMAIN + "/ulearning/index.html#/index/courseList"
            } else {
              this.welinkId = res.result.welinkid;
              this.weLinkBind();
            }
          }
        })
        .catch((err) => {
          if (err.code === 0) {
            setTimeout(() => {
              history.go(-1);
            }, 1900);
          }
          if (err.code === 2) {
            if (this.isLogin) {
              this.$router.replace({
                name: "welinkBind",
              });
              sessionStorage.setItem("welinkId", err.result);
            } else {
              this.welinkId = err.result;
              this.weLinkBind();
            }
          }
        });
    },
    weLinkBind() {
      let datas = {
        welinkId: this.welinkId,
      };
      weLinkBind(datas)
        .then((res) => {
          if (res.code == 1) {
            this.$toast(res.message, {
              type: "success",
              duration: 2000,
            });
            setTimeout(() => {
              history.go(-1);
            }, 1900);
          }
        })
        .catch((err) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.welink-code-con {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  padding-top: 150px;
  .welink-qrcode {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}
</style>